import React, { useEffect, useState } from "react";
import { Skeleton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useSelector } from "react-redux";

import CustomAvatar from "../../CustomAvatar";
import RightLeftChecker from "../../../../utils/RightLeftChecker";
import { getSettingState } from "../../../../redux/features/settingSlice";
import unknownAvatar from "../../../../media/svg/Avatar/Avatar.svg";
import NewlineText from "../../../../utils/NewLineText";

const ProfileHeader = ({ data, isLoading, myProfile }) => {
  const [openBio, setOpenBio] = useState(false);
  const { userData } = useSelector(getSettingState);
  const preLine = NewlineText(data?.bio)?.length > 1;

  useEffect(() => {
    setOpenBio(isLoading);
  }, [isLoading]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          height: "64px",
          position: "fixed",
          right: 0,
          left: 0,
          backgroundColor: "white.main",
          zIndex: 1,
        }}
      >
        {(isLoading || !data) && !myProfile ? (
          <Skeleton
            sx={{ textAlign: "center", mt: "10px" }}
            width={"150px"}
            height={40}
          />
        ) : (
          <Typography
            noWrap
            sx={{
              textAlign: "center",
              mt: "20px",
              maxWidth: "230px",
              fontSize: "20px",
              lineHeight: "28px",
            }}
          >
            {userData || !myProfile ? data?.username : "Unknown Visitor"}
          </Typography>
        )}
      </Box>
      <Box sx={{ padding: "8px 16px 0 16px", mt: "64px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <CustomAvatar
            src={userData || !myProfile ? data?.avatar : unknownAvatar}
            size={64}
          />
          {(isLoading || !data) && !myProfile ? (
            <Skeleton sx={{ ml: "8px" }} width={"180px"} height={48} />
          ) : (
            <Typography
              sx={{
                ml: "8px",
                fontFamily: "Tahrir",
                fontWeight: 500,
                fontSize: "32px",
              }}
            >
              {userData || !myProfile ? data?.nickname : "Unknown Visitor"}
            </Typography>
          )}
        </Box>
        <Box
          onClick={() => setOpenBio(!openBio)}
          sx={{
            display: "flex",
            flexDirection: isLoading ? "column" : "unset",
            mt: "8px",
            cursor: "pointer",
            direction: RightLeftChecker(data?.bio) ? "rtl" : "ltr",
          }}
        >
          {(isLoading || !data) && !myProfile ? (
            <Skeleton width={"100%"} height={20} />
          ) : (
            <Typography
              noWrap={!openBio}
              sx={{
                fontSize: "14px",
                lineHeight: "24px",
                mr: "4px",
                direction: RightLeftChecker(data?.bio) ? "rtl" : "ltr",
                whiteSpace: openBio ? "pre-line" : "nowrap",
              }}
            >
              {data?.bio}
              {openBio && (data?.bio.length > 52 || preLine) && (
                <Typography
                  component={"span"}
                  sx={{
                    display: "inline-flex",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: 600,
                    color: "secondary.main",
                    px: "8px",
                  }}
                >
                  Less
                </Typography>
              )}
            </Typography>
          )}

          {!openBio && (data?.bio.length > 52 || preLine) && (
            <Typography
              component={"span"}
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: 600,
                color: "secondary.main",
              }}
            >
              More
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default ProfileHeader;
